// app/javascript/controllers/scroll_to_errors_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["errorExplanation"]

  connect() {
    if (this.hasErrorExplanationTarget) {
      this.errorExplanationTarget.scrollIntoView({ behavior: "smooth" });
    }
  }
}
